export enum MilestoneAssigneeStatus {
  AssignedToMe = "Assigned To Me",
  ImTheApprover = "I'm the Approver",
  ImTheObserver = "I'm the Observer",
  FavoriteTasks = "Favorite Tasks",
}